// Pipeline constants from Orchestration.txt
export const DEFAULT_KPIS = [
  "TITER", "Specific_Growth_Rate", "Viability",
  "qO2_est", "qGluc", "qLac", "Glycolysis_Index",
  "Lactate_Switch", "Gln_Index", "Nutrient_Stress",
  "Stationary_Score", "Death_Score", "Hypoxia_Score",
  "OXPHOS_Index"
];

export const DEFAULT_EVENT_VARS = [
  "pH", "DO", "Base_Consumed_g", "FeedA_Added_g", "Glucose_Added_g",
  "FeedB_Added_g", "O2_Sparge_slpm", "CO2_Sparge_slpm", "Agitation"
];

// Required core columns for the pipeline
export const REQUIRED_CORE_COLUMNS = ["Run_ID", "Days", "DateTime", "Good", "VCD"];

// Pipeline steps configuration
export const PIPELINE_STEPS = [
  {
    id: 0,
    title: "Config Unpack",
    description: "Extract and validate configuration parameters",
    icon: "⚙️",
    details: "Parse reference run IDs, KPIs, event variables, and thresholds"
  },
  {
    id: 1,
    title: "Scaling & Reference",
    description: "Scale KPIs and build reference profile",
    icon: "📊",
    details: "Normalize data using MAD scaling and create DTW-aligned reference"
  },
  {
    id: 2,
    title: "Weights & Metric",
    description: "Calculate optimal KPI weights and distance metric",
    icon: "⚖️",
    details: "Blend linear and gradient boosting weights, select best metric"
  },
  {
    id: 3,
    title: "Phases, Scores, Anomalies",
    description: "Segment growth phases and detect anomalies",
    icon: "🔍",
    details: "Identify Growth/Stationary/Death phases and EWMA anomalies"
  },
  {
    id: 4,
    title: "Event Log, FP Suppression",
    description: "Generate event log and filter false positives",
    icon: "📋",
    details: "Log process deviations and apply active learning filters"
  },
  {
    id: 5,
    title: "Lift, Lag, RCA",
    description: "Build lift matrix and perform root cause analysis",
    icon: "🎯",
    details: "Calculate lift scores, lag correlations, and generate recommendations"
  },
  {
    id: 6,
    title: "Sensor Health & Trends",
    description: "Monitor sensor drift and batch trends",
    icon: "🌡️",
    details: "Assess MAD/EWMA ratios and multi-batch incident patterns"
  },
  {
    id: 7,
    title: "Tiered ML",
    description: "Apply machine learning based on data size",
    icon: "🤖",
    details: "Spearman/trees (<10), Logistic/Tree (10-29), Auto-ML (30+)"
  },
  {
    id: 8,
    title: "Assemble Result",
    description: "Compile all analysis results",
    icon: "📦",
    details: "Gather distances, anomalies, events, lift, RCA, and ML results"
  },
  {
    id: 9,
    title: "Audit Bundle",
    description: "Generate audit log and finalize pipeline",
    icon: "📝",
    details: "Create timestamped audit trail and save to cache"
  }
];
